import React, {Component} from "react"
import PropTypes from "prop-types"

import {H4} from "@irati/ui/src/Typography/Heading"
import {injectIntl} from "@irati/utils/lang"
import {pollUsersToStringTitle, pollUsersToStringSubtitle} from "@irati/recognition/utils/pollUsersToString"

import TeamList from "../../../TeamList"
import {Bold} from "../styled/Card"

class Poll extends Component {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    formatMessage: PropTypes.func.isRequired
  }

  render() {
    const {poll, formatMessage} = this.props

    const pollWinnersResults = poll.winners.results.map(({user}) => user)
    const title = pollUsersToStringTitle(pollWinnersResults, formatMessage)
    const subTitle = pollUsersToStringSubtitle(pollWinnersResults, poll.title, formatMessage)

    return (
      <H4>
        <Bold>{title}</Bold>
        {subTitle}
        <TeamList teams={poll.teams.results} showMobileTooltip={false} />
      </H4>
    )
  }
}

export default injectIntl(Poll)
